import BaseMobileWorkbenchLoader from '@framework/workbench/loader/base/base-mobile-loader';
import { IWorkbench, IWorkbenchSettings, IPlatformSetting, SurfaceService, MiddlewareService } from '@tencent/workbench';
import TocMobileWorkbenchSetting from '@framework/workbench/setting/toc/toc-mobile-setting';

export default class TocMobileWorkbenchLoader extends BaseMobileWorkbenchLoader {
    public constructor(
        workbench: IWorkbench,
        middlewareService: MiddlewareService,
        surfaceService: SurfaceService,
    ) {
        super(workbench, middlewareService, surfaceService);
    }
    /**
     * 创建workbench的settings配置
     * @protected
     */
    protected createSettings(): IWorkbenchSettings<IPlatformSetting> {
        return new TocMobileWorkbenchSetting().createSettings();
    }
}
